// removed by extract-text-webpack-plugin
module.exports = {"round":"_3Ro3h8p0lbwsyy0qZZVFzx","roundActive":"_28TZMvq7uRtMzO_7siMRdQ","roundHover":"E8T4vedJuj3AEjgnpH_ef"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/Round/index.css
// module id = 156
// module chunks = 0